import {
  INotification,
  notificationEnums,
} from "@freetech/models/notifications";

export const getFreelancerNotificationDescription = (
  notification: INotification
): string | undefined => {
  const { type, afterData, beforeData } = notification;

  switch (type) {
    case notificationEnums.FreelancerNotificationType
      .FREELANCER_PAYMENT_CREATED:
      if (afterData && "description" in afterData) {
        return afterData.description as string;
      }
      if (afterData && "status" in afterData) {
        return `Status: ${afterData.status}`;
      }
      return "Your payment has been initiated";

    case notificationEnums.FreelancerNotificationType
      .FREELANCER_PAYMENT_UPDATED:
      if (
        afterData &&
        beforeData &&
        "status" in afterData &&
        "status" in beforeData
      ) {
        return `Status changed from ${beforeData.status} to ${afterData.status}`;
      }
      return "Payment details have been updated";

    case notificationEnums.FreelancerNotificationType
      .FREELANCER_PROJECT_ASSIGNMENT_CREATED:
      if (afterData && "description" in afterData) {
        return afterData.description as string;
      }
      if (afterData && "startDate" in afterData && "endDate" in afterData) {
        const startDate = new Date(afterData.startDate as string);
        const endDate = new Date(afterData.endDate as string);
        return `Duration: ${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
      }
      return "New project assignment requires your attention";

    case notificationEnums.FreelancerNotificationType
      .FREELANCER_PROJECT_ASSIGNMENT_COMPLETED:
      if (afterData && "completedDate" in afterData) {
        const completedDate = new Date(afterData.completedDate as string);
        return `Completed on ${completedDate.toLocaleDateString()}`;
      }
      return "Great job on completing this assignment!";

    case notificationEnums.FreelancerNotificationType
      .FREELANCER_AGREEMENT_CREATED:
      return "Please review and sign your independent engineer agreement to continue working";

    case notificationEnums.FreelancerNotificationType
      .FREELANCER_AGREEMENT_REMINDER:
      return "Your agreement signature is required to continue receiving assignments";

    case notificationEnums.FreelancerNotificationType
      .FREELANCER_ONBOARDING_COMPLETE:
      return "Welcome to FreeTech! You can now start receiving project assignments";

    default:
      return undefined;
  }
};
